<template>
    <div :style="hkTipStyle">
        <el-tooltip class="item" effect="info" placement="right">
            <div slot="content" v-html="infoText"></div>
            <el-button class="info-btn">
                <i class="el-icon-question" />
            </el-button>
        </el-tooltip>
    </div>
</template>

<script>
    export default {
        name: "hkTip",
        props:{
            hkTipStyle:{
                type:Object,
                default: () => {
                    return {
                        display: 'inline'
                    }
                }
            }
        },
        data(){
            return {
                infoText: "",
            }
        },
        mounted(){
            this.initHkTip();
        },
        methods:{
            initHkTip(){
                this.infoText =
                                "<div style='color: GrayText;margin: 16px 16px;text-align: justify;'>" +
                                "   <p><i class=\"fa fa-exclamation-triangle\" style='color: greenyellow;'></i>汇款提示：</p>" +
                                "   <p>1、投资者T日的申（认）购申请，对应足额申购资金应在T日15：00之前（不含15：00）到账。资金到账时间以本公司指定收款银行账户记录的足额资金到账时间为准。若申（认）购资金未按时到账，或与交易申请金额不一致，则申（认）购申请将确认失败。跨行汇款，各银行系统之间需要一定的处理时间，请您务必提前汇款，确保资金按时、足额到账。</p>" +
                                "   <p>2、投资者办理汇款业务产生的手续费，由投资者承担。各银行汇款业务的手续费收取情况请咨询各发卡银行。</p>" +
                                "   <p>3、<span style='color: red'>投资者汇款时需使用提交交易申请时所选择的银行卡转账汇款，</span>不能使用其他银行卡转账。请勿使用支付宝、微信等第三方平台转账、现金汇款等方式，此类汇款方式无效。前述汇款方式均将导致您的申（认）购申请确认失败。</p>" +
                                "   <p>4、如因跨行汇款以及银行系统问题等原因导致本公司收款银行提供的账户明细无法正确识别投资者来款银行号、户名，本公司将无法办理资金入账，申（认）购申请将确认失败或无效。请投资者主动与本公司客服电话95522联系进行资金退款。</p>" +
                                "   <p>5、由于汇款转账操作失误等导致的申（认）购失败、资金清退延误等风险或损失，由投资者自行承担。</p>" +
                                "</div>"
            }
        },
    }
</script>

<style scoped>
    .info-btn{
        border:none;
        padding: 6px 0;
    }
    .el-icon-question{
        color: greenyellow;
        font-size: 1.2em;
    }
</style>
